/**
 * Translator, dictionary - accurate translate — page/word translation
 *
 * Declares one WAR group matched to every URL with no use_dynamic_url: scripts/*,
 * images/*, styles/* and fonts/*. The badge and detect images load via <img> with no
 * CORS grant, and the injected content script and stylesheet corroborate from
 * independent fixed URLs.
 *
 * Manifest verified against version 1.9.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bebmphofpgkhclocdbgomhnjcpelbenh';

export const translatorDictionary: ExtensionDefinition = {
  id: ID,
  name: 'Translator, dictionary - accurate translate',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Scripts, images, styles and fonts exposed to every origin with no dynamic URL. The ' +
    'PNG image loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-detect-png',
      kind: 'web-accessible-resource',
      description:
        'Load images/detect.png via <img> — a vendor UI image exposed to every origin; ' +
        'needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/detect.png'),
    },
    {
      id: 'war-content-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch scripts/content.js — the injected content script on a stable path, ' +
        'corroborating from an independent resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'scripts/content.js'),
    },
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch styles/content.css — the injected content stylesheet, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'styles/content.css'),
    },
  ],
};
